/**
 * @fileoverview gRPC-Web generated client stub for admpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: admpb/profile.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../google/type/date_pb.js')
const proto = {};
proto.admpb = require('./profile_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.admpb.ProfileServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.admpb.ProfileServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.ReadProfileRequest,
 *   !proto.admpb.ReadProfileResponse>}
 */
const methodDescriptor_ProfileService_ReadProfile = new grpc.web.MethodDescriptor(
  '/admpb.ProfileService/ReadProfile',
  grpc.web.MethodType.UNARY,
  proto.admpb.ReadProfileRequest,
  proto.admpb.ReadProfileResponse,
  /**
   * @param {!proto.admpb.ReadProfileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ReadProfileResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.ReadProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.admpb.ReadProfileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.ReadProfileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.ProfileServiceClient.prototype.readProfile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.ProfileService/ReadProfile',
      request,
      metadata || {},
      methodDescriptor_ProfileService_ReadProfile,
      callback);
};


/**
 * @param {!proto.admpb.ReadProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.ReadProfileResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.ProfileServicePromiseClient.prototype.readProfile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.ProfileService/ReadProfile',
      request,
      metadata || {},
      methodDescriptor_ProfileService_ReadProfile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.ListProfileRequest,
 *   !proto.admpb.ListProfileResponse>}
 */
const methodDescriptor_ProfileService_ListProfile = new grpc.web.MethodDescriptor(
  '/admpb.ProfileService/ListProfile',
  grpc.web.MethodType.UNARY,
  proto.admpb.ListProfileRequest,
  proto.admpb.ListProfileResponse,
  /**
   * @param {!proto.admpb.ListProfileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ListProfileResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.ListProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.admpb.ListProfileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.ListProfileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.ProfileServiceClient.prototype.listProfile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.ProfileService/ListProfile',
      request,
      metadata || {},
      methodDescriptor_ProfileService_ListProfile,
      callback);
};


/**
 * @param {!proto.admpb.ListProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.ListProfileResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.ProfileServicePromiseClient.prototype.listProfile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.ProfileService/ListProfile',
      request,
      metadata || {},
      methodDescriptor_ProfileService_ListProfile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.ExecuteProfileRequest,
 *   !proto.admpb.ExecuteProfileResponse>}
 */
const methodDescriptor_ProfileService_ExecuteProfile = new grpc.web.MethodDescriptor(
  '/admpb.ProfileService/ExecuteProfile',
  grpc.web.MethodType.UNARY,
  proto.admpb.ExecuteProfileRequest,
  proto.admpb.ExecuteProfileResponse,
  /**
   * @param {!proto.admpb.ExecuteProfileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ExecuteProfileResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.ExecuteProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.admpb.ExecuteProfileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.ExecuteProfileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.ProfileServiceClient.prototype.executeProfile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.ProfileService/ExecuteProfile',
      request,
      metadata || {},
      methodDescriptor_ProfileService_ExecuteProfile,
      callback);
};


/**
 * @param {!proto.admpb.ExecuteProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.ExecuteProfileResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.ProfileServicePromiseClient.prototype.executeProfile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.ProfileService/ExecuteProfile',
      request,
      metadata || {},
      methodDescriptor_ProfileService_ExecuteProfile);
};


module.exports = proto.admpb;

